import React from "react";
import { Grid, Typography, Container } from "@mui/material";
import Twitter from "../../assets/Vector.svg";
import Subtract from "../../assets/Subtract.svg";
import MediumNegative from "../../assets/Medium - Negative.svg";
import Book from "../../assets/book.svg";
import Monitor from "../../assets/monitor-1.png";
import "./index.css";
export default function index() {
  return (
    <>
      <Container>
        <Grid container>
          <Grid item className="footer-links">
            <Typography className="footer-text">CONTACT</Typography>
            <Typography className="footer-text">WHITEPAPER</Typography>
            <Typography className="footer-text">OFFICIAL TERRASWAP</Typography>
            <Typography className="footer-text">WE'RE HIRING</Typography>
            <Typography className="footer-text">AUDIT</Typography>
          </Grid>
          <Grid item className="footer-links-2">
            <img src={Twitter} />
            <img src={Subtract} />
            <img src={MediumNegative} />
            <img src={Book} />
            <img src={Monitor} />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
